import SegmentType from '../interfaces/Segment';
import SegmentNames from '../interfaces/SegmentNames';
import SegmentRange from './SegmentRange';

export default class Segment {
  constructor(private segment: SegmentType) {}

  hasNoOverlapping(segment: SegmentType): boolean {
    return SegmentNames.every((s) =>
      new SegmentRange(this.segment[s]).isOverlapping(segment[s])
    );
  }
}
